export const fragSampler = `
precision mediump float;

uniform sampler2D uSamplers[1];
varying vec2 outTexCoord;

void main ()
{
  gl_FragColor = texture2D(uSamplers[0], outTexCoord);
}
`;
